import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Button from '@mui/material/Button';

import { Outlet, Link } from "react-router-dom";

const AppBoardScreen = () => {
    return (
        <Box id="AppBoardScreen2" className="AppBoardScreen AppBoardScreen2" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/CustomerName">
                        <Button variant="outlined" size="large">Regresar</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">﻿¿Es importante realizar el cambio de estado junto con el cambio de nombre pero esto solo se puede realizar en una de las oficinas de manera presencial. 

Lo ayudaremos a localizar la más cercana a usted</h2>
                </Grid>
                <Grid item xs={12}>
                    <Link to="/dmv/cambio/ForThisWeWillNeedYouProvideWithYourPostal">
                        <Button variant="contained" color="success" size="large" sx={{ width: "50%" }}>Siguiente</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <Link to="/dmv/">
                        <Button variant="contained" color="success" size="large" sx={{ width: "50%" }}>Cancelar</Button>
                    </Link>
                </Grid>
                <Outlet/>
            </Grid>
        </Box>
    );
};

export default AppBoardScreen;